const HOUR_MS = 60 * 60 * 1_000;
const DAY_MS = 24 * HOUR_MS;
const MONTH_DAYS = 30;
const YEAR_MONTHS = 12;

const withAgo = (count: number, unit: "hour" | "day" | "month" | "year") =>
  `${count} ${unit}${count === 1 ? "" : "s"} ago`;

export const formatSocialTokenAge = (
  value: string | null | undefined,
  now = Date.now(),
) => {
  if (!value) return "recently";

  const timestamp = Date.parse(value);
  if (!Number.isFinite(timestamp) || timestamp > now) return "recently";

  const elapsedMs = now - timestamp;
  const elapsedDays = Math.floor(elapsedMs / DAY_MS);

  if (elapsedDays >= MONTH_DAYS) {
    const elapsedMonths = Math.floor(elapsedDays / MONTH_DAYS);
    if (elapsedMonths >= YEAR_MONTHS) {
      return withAgo(Math.floor(elapsedMonths / YEAR_MONTHS), "year");
    }
    return withAgo(elapsedMonths, "month");
  }

  if (elapsedMs >= 72 * HOUR_MS) {
    return withAgo(elapsedDays, "day");
  }

  return `${Math.max(1, Math.floor(elapsedMs / HOUR_MS))}h ago`;
};
